var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-layout"},[_c('div',{staticClass:"common-layout.header"},[_vm._t("header")],2),_c('div',{staticClass:"common-layout.container"},[_vm._t("container")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }